import {Component, Input, OnInit} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {PlatformCommandResponse} from '@shared/commands/command-base';

@Component({
    standalone: false,
    selector: 'app-workspace-users',
  templateUrl: './workspace-users.component.html',
  styleUrl: './workspace-users.component.scss'
})
export class WorkspaceUsersComponent implements OnInit, IPlatformToolComponent{
  @Input() magicLinkModel: MagicLinkModel;
  @Input() handler: IPlatformToolHandler;
  @Input() selectedTab: TabModel;
  @Input() invalidateSubject: InvalidateSubject = new InvalidateSubject();
  userType: any;
  users: any[] = [];
  state: 'loading' | 'error' | 'empty' | 'ready' = 'loading';

  ngOnInit(): void {
    // Rendered from the model already on the link, with no fetch: until it is there, the view shows the shimmer.
    if (!this.magicLinkModel) {
      return;
    }
    const tabData = this.magicLinkModel.tabBar?.tabs?.[0]?.tabData;
    const workspace = tabData?.WorkspaceModel;
    this.userType = tabData?.UserType;
    const users = this.userType === 'Licensed' ? workspace?.licensedUsers : workspace?.nonLicensedUsers;
    if (!workspace || typeof workspace !== 'object' || (users != null && !Array.isArray(users))) {
      this.state = 'error';
      return;
    }
    this.users = users ?? [];
    this.state = this.users.length ? 'ready' : 'empty';
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return false;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return false;
  }

  onLoad() {
  }

}
